<style scoped>
.maintenance-page {
	min-height: 100vh;
}
.maintenance-body {
	flex: 1 1 auto;
}
.maintenance-icon {
	font-size: 3rem;
	line-height: 1;
}
.maintenance-copy {
	max-width: 32rem;
}
</style>
<template>
	<main class="maintenance-page d-flex flex-column">
		<!-- Same site header/branding every RMO page uses -->
		<Header />
		<section class="maintenance-body container d-flex align-items-center py-5">
			<div class="maintenance-copy mx-auto text-center">
				<i
					class="bi bi-tools maintenance-icon text-primary"
					aria-hidden="true"
				></i>
				<h1 class="h2 mt-4 mb-3">We'll be right back</h1>
				<p v-if="message" class="lead mb-4">{{ message }}</p>
				<p v-else class="lead text-muted mb-4">
					This site is temporarily down for maintenance. Thanks for your
					patience.
				</p>
				<p class="mb-4">
					We're doing a little work behind the scenes and expect to be back
					online shortly.
				</p>
				<p v-if="startedAtText" class="small text-muted mb-0">
					Maintenance started {{ startedAtText }}
				</p>
				<p class="small text-muted mt-4 mb-0">
					<span
						class="spinner-border spinner-border-sm me-2"
						role="status"
						aria-hidden="true"
					></span>
					Checking automatically — this page will refresh when service resumes.
				</p>
			</div>
		</section>
	</main>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Header from "@/rmo/components/Header.vue";
import { useRMOMaintenance } from "@/rmo/maintenance";
import { formatDate } from "@/format";

const { message, startedAt } = useRMOMaintenance();

const startedAtText = computed((): string | null => {
	if (!startedAt.value) {
		return null;
	}
	const date = new Date(startedAt.value);
	if (Number.isNaN(date.getTime())) {
		return null;
	}
	return formatDate(date);
});
</script>
